import { render } from "./ui-sidebar.vue?vue&type=template&id=208f0d7c&scoped=true"
import script from "./ui-sidebar.vue?vue&type=script&lang=js"
export * from "./ui-sidebar.vue?vue&type=script&lang=js"

import "./ui-sidebar.vue?vue&type=style&index=0&id=208f0d7c&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208f0d7c"]])

export default __exports__